import classNames from 'classnames'
import { forwardRef } from 'react'
import type { SfRadioProps } from '@storefront-ui/react'

interface ExtendedSfRadioProps extends Omit<SfRadioProps, `value`> {
  value?: string | boolean;
}

const SfRadio = forwardRef<HTMLInputElement, ExtendedSfRadioProps>(
  ( props, ref ) => {
    const { invalid, className, disabled, value, ...attributes } = props

    return (
      <input
        ref={ref}
        type="radio"
        disabled={disabled}
        value={typeof value === `boolean` ? value.toString() : value}
        className={classNames(
          `border-2 bg-clip-content rounded-full appearance-none cursor-pointer focus-visible:outline focus-visible:outline-offset disabled:border-disabled-500 disabled:cursor-not-allowed disabled:checked:bg-disabled-500 disabled:checked:border-disabled-500 block mb-4 themed-radio--showCheck mr-[10px] !my-0 w-[22px] !p-0 h-[22px] min-w-[22px]`,
          invalid && !disabled
            ? `border-negative-700 checked:bg-negative-700 hover:border-negative-800 hover:checked:bg-negative-800 active:border-negative-900 active:checked:bg-negative-900`
            : `border-neutral-500 active:border-primary-900 hover:border-primary-700 checked:bg-primary-700 checked:border-primary-700 hover:checked:bg-primary-800 hover:checked:border-primary-800 active:checked:bg-primary-900 active:checked:border-primary-900`,
          className
        )}
        {...attributes}
      />
    )
  }
)

SfRadio.displayName = `SfRadio`

export default SfRadio
